import React from 'react'
import { useKhmdjhyQCMutation } from '../../store/BnsKeJiApi'
import { App } from 'antd'
function ContactAddFriendDel(props) {
    const {message} = App.useApp()
    const [khmdjhyQC] = useKhmdjhyQCMutation()
    return (
        <a onClick={() => {
            khmdjhyQC({
                'khmd_id': props.khmd_id,
            }).then((res) => {
                if(res.data.Status==='success'){
                    message.success('清除成功！')
                }else{
                    message.error('清除失败！'+res.data.Message)
                }
            })
        }}>清除</a>
    )
}

export default ContactAddFriendDel